export default function NotificationIcon() {
  return (
    <svg
      width="21"
      height="25"
      viewBox="0 0 21 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.30127 7.21519C2.38628 5.86093 2.98421 4.58998 3.97333 3.66106C4.96245 2.73214 6.2684 2.2151 7.62532 2.21519H8.33039V1.26582C8.33039 0.930106 8.46375 0.608139 8.70114 0.370751C8.93852 0.133363 9.26049 0 9.59621 0C9.93193 0 10.2539 0.133363 10.4913 0.370751C10.7287 0.608139 10.862 0.930106 10.862 1.26582V2.21519H11.5671C12.924 2.2151 14.23 2.73214 15.2191 3.66106C16.2082 4.58998 16.8061 5.86093 16.8911 7.21519L17.1709 11.6886C17.279 13.3939 17.8516 15.0372 18.8266 16.4405C19.0283 16.7305 19.1516 17.0677 19.1844 17.4194C19.2172 17.7711 19.1584 18.1253 19.0138 18.4475C18.8692 18.7698 18.6436 19.0492 18.359 19.2584C18.0745 19.4677 17.7406 19.5998 17.3899 19.6418L13.0772 20.1582V21.519C13.0772 22.4422 12.7105 23.3276 12.0577 23.9804C11.4048 24.6333 10.5194 25 9.59621 25C8.67299 25 7.78758 24.6333 7.13476 23.9804C6.48194 23.3276 6.1152 22.4422 6.1152 21.519V20.1582L1.80254 19.6405C1.45202 19.5984 1.11837 19.4663 0.833987 19.2571C0.549605 19.0479 0.324163 18.7687 0.179565 18.4467C0.0349672 18.1246 -0.0238714 17.7706 0.0087663 17.4191C0.041404 17.0676 0.164408 16.7304 0.365829 16.4405C1.34082 15.0372 1.91338 13.3939 2.02152 11.6886L2.30127 7.21519ZM8.01393 21.519C8.01393 21.9386 8.18063 22.3411 8.47737 22.6378C8.7741 22.9346 9.17656 23.1013 9.59621 23.1013C10.0159 23.1013 10.4183 22.9346 10.715 22.6378C11.0118 22.3411 11.1785 21.9386 11.1785 21.519V20.5696H8.01393V21.519Z"
        fill="#76B340"
      />
      <circle
        cx="15.6467"
        cy="5.27873"
        r="4.56329"
        fill="black"
        stroke="white"
      />
    </svg>
  );
}

export function LeftGetStartedIcon() {
  return (
    <svg
      width="19"
      height="4"
      viewBox="0 0 19 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 4C1.44 4 0.966667 3.80667 0.58 3.42C0.193333 3.03333 0 2.56033 0 2.001C0 1.44167 0.193333 0.968334 0.58 0.581C0.966667 0.193667 1.44 0 2 0C2.46533 0 2.87767 0.141667 3.237 0.425C3.59633 0.708333 3.829 1.06667 3.935 1.5H19V2.5H3.935C3.82833 2.93333 3.59567 3.29167 3.237 3.575C2.87833 3.85833 2.466 4 2 4Z"
        fill="black"
      />
    </svg>
  );
}
export function RightGetStartedIcon() {
  return (
    <svg
      width="19"
      height="4"
      viewBox="0 0 19 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 0C17.56 0 18.0333 0.193333 18.42 0.58C18.8067 0.966667 19 1.43967 19 1.999C19 2.55833 18.8067 3.03167 18.42 3.419C18.0333 3.80633 17.56 4 17 4C16.5347 4 16.1223 3.85833 15.763 3.575C15.4037 3.29167 15.171 2.93333 15.065 2.5L0 2.5V1.5L15.065 1.5C15.1717 1.06667 15.4043 0.708333 15.763 0.425C16.1217 0.141667 16.534 0 17 0Z"
        fill="black"
      />
    </svg>
  );
}
export function XIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 23.5L14.791 17.2105M14.791 17.2105L8.5 8.5H12.6655L17.2105 14.791L23.5 8.5M14.791 17.2105L19.333 23.5H23.5L17.209 14.7895"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 16C31 24.2845 24.2845 31 16 31C7.7155 31 1 24.2845 1 16C1 7.7155 7.7155 1 16 1C24.2845 1 31 7.7155 31 16Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function LinkedinIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2883 11.213C17.6541 11.213 17.1844 11.373 16.8168 11.5751C16.7578 11.3655 16.5642 11.2121 16.3359 11.258H13.5444C13.2684 11.2121 13.0448 11.4357 13.1299 11.7257V22.0163C13.0448 22.2783 13.2684 22.5028 13.5444 22.4841H16.3359C16.6119 22.5028 16.8355 22.2783 16.8355 22.0023L16.8345 15.783C16.8336 15.7802 16.8233 15.4827 17.0114 15.2778C17.162 15.1151 17.4211 15.0318 17.7794 15.0318C18.3763 15.0318 18.642 15.276 18.7411 15.8223V22.0023C18.6429 22.2783 18.8665 22.5028 19.1425 22.4841H22.0846C22.3606 22.5028 22.5842 22.2783 22.485 22.0023V15.6146C22.5833 12.3665 20.2697 11.213 18.2883 11.213ZM21.5841 21.5486H19.642V15.8223C19.642 14.7175 18.9282 14.0327 17.7804 14.0327C17.1311 14.0327 16.6259 14.2235 16.2779 14.5996C15.7943 15.1235 15.8317 15.7877 15.9355 15.9355V21.5486H14.0439V12.2122H15.8364V12.5265C15.8356 12.6201 15.8613 12.7121 15.9105 12.7918C15.9597 12.8715 16.0303 12.9357 16.1144 12.977C16.1984 13.0183 16.2924 13.0351 16.3855 13.0254C16.4787 13.0157 16.5672 12.98 16.6409 12.9222L16.7719 12.8212C17.1508 12.5228 17.5427 12.2131 18.2893 12.2131C19.062 12.2131 21.5851 12.4591 21.5851 15.6156L21.5841 21.5486ZM10.3224 6.54858C9.2728 6.54858 8.41962 7.40177 8.41962 8.45142C8.41962 9.50106 9.2728 10.3542 10.3224 10.3542C11.3721 10.3542 12.2253 9.50106 12.2253 8.45142C12.2253 7.40177 11.3721 6.54858 10.3224 6.54858ZM10.3224 9.35512C9.82476 9.35512 9.41874 8.94911 9.41874 8.45142C9.41874 7.95372 9.82476 7.54771 10.3224 7.54771C10.8201 7.54771 11.2262 7.95372 11.2262 8.45142C11.2262 8.94911 10.8201 9.35512 10.3224 9.35512ZM11.6584 11.2121H8.88176C8.60578 11.2121 8.3822 11.4357 8.45142 11.7257V22.0163C8.3822 22.2783 8.60578 22.5028 8.88176 22.4841H11.6584C11.9343 22.5028 12.1579 22.2783 12.1579 22.0023V11.7117C12.1579 11.5792 12.1053 11.4521 12.0116 11.3584C11.9179 11.2647 11.7909 11.2121 11.6584 11.2121ZM11.258 21.5486H9.38132V12.2122H11.258V21.5486Z"
        fill="currentColor"
      />
      <path
        d="M15 0C6.7282 0 0 6.7282 0 15C0 23.2718 6.7282 30 15 30C23.2718 30 30 23.2718 30 15C30 6.7282 23.2718 0 15 0ZM15 29.0009C7.28015 29.0009 0.999127 22.7198 0.999127 15C0.999127 7.28015 7.28015 0.999127 15 0.999127C22.7198 0.999127 29.0009 7.28015 29.0009 15C29.0009 22.7198 22.7198 29.0009 15 29.0009Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function YoutubeIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8838 15.9999L12.5117 20.8837V11.1162L20.8838 15.9999Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function FacebookIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C12.0333 0 9.13319 0.879734 6.66645 2.52795C4.19971 4.17618 2.27713 6.51886 1.14181 9.25975C0.00649901 12.0006 -0.290551 15.0166 0.288228 17.9263C0.867006 20.8361 2.29562 23.5088 4.3934 25.6066C6.49119 27.7044 9.16393 29.133 12.0736 29.7118C14.9834 30.2906 17.9994 29.9935 20.7403 28.8582C23.4811 27.7229 25.8238 25.8003 27.472 23.3335C29.1203 20.8668 30 17.9667 30 15C29.9953 11.0232 28.4135 7.21059 25.6014 4.39856C22.7894 1.58652 18.9768 0.00467037 15 0ZM15.8824 28.2059V18.2353H19.7059C19.9399 18.2353 20.1643 18.1423 20.3298 17.9769C20.4953 17.8114 20.5882 17.587 20.5882 17.3529C20.5882 17.1189 20.4953 16.8945 20.3298 16.729C20.1643 16.5635 19.9399 16.4706 19.7059 16.4706H15.8824V12.6471C15.8824 11.945 16.1612 11.2717 16.6577 10.7753C17.1541 10.2789 17.8274 10 18.5294 10H20.8824C21.1164 10 21.3408 9.90703 21.5063 9.74156C21.6717 9.57609 21.7647 9.35166 21.7647 9.11764C21.7647 8.88363 21.6717 8.6592 21.5063 8.49373C21.3408 8.32825 21.1164 8.23529 20.8824 8.23529H18.5294C17.3593 8.23529 16.2372 8.7001 15.4098 9.52747C14.5825 10.3548 14.1177 11.477 14.1177 12.6471V16.4706H10.2941C10.0601 16.4706 9.83568 16.5635 9.6702 16.729C9.50473 16.8945 9.41177 17.1189 9.41177 17.3529C9.41177 17.587 9.50473 17.8114 9.6702 17.9769C9.83568 18.1423 10.0601 18.2353 10.2941 18.2353H14.1177V28.2059C10.6915 27.977 7.48843 26.4254 5.18486 23.879C2.88129 21.3325 1.65755 17.9905 1.77208 14.5586C1.8866 11.1267 3.33042 7.8737 5.79863 5.48648C8.26684 3.09926 11.5662 1.76474 15 1.76474C18.4338 1.76474 21.7332 3.09926 24.2014 5.48648C26.6696 7.8737 28.1134 11.1267 28.2279 14.5586C28.3425 17.9905 27.1187 21.3325 24.8151 23.879C22.5116 26.4254 19.3085 27.977 15.8824 28.2059Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5.6H15.1661V8.4H0V5.6ZM0 2.8H15.1661V0H0V2.8ZM0 14H9.65118V11.2H0V14ZM20.6949 9.618L21.6738 8.624C21.8013 8.49422 21.9529 8.39125 22.1196 8.32099C22.2864 8.25074 22.4652 8.21458 22.6458 8.21458C22.8264 8.21458 23.0052 8.25074 23.172 8.32099C23.3388 8.39125 23.4903 8.49422 23.6178 8.624L24.5967 9.618C25.1344 10.164 25.1344 11.046 24.5967 11.592L23.6178 12.586L20.6949 9.618ZM19.716 10.612L12.4087 18.032V21H15.3316L22.6389 13.58L19.716 10.612Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function Freeze() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.89474 6.728L11.0526 3.528L9.93947 2.4L7.89474 4.472V1.6H6.31579V4.472L4.27105 2.4L3.15789 3.528L6.31579 6.728V8H5.06053L1.90263 4.8L0.789474 5.928L2.83421 8H0V9.6H2.83421L0.789474 11.672L1.90263 12.8L5.06053 9.6H6.31579V10.872L3.15789 14.072L4.27105 15.2L6.31579 13.128V16H7.89474V13.128L9.93947 15.2L11.0526 14.072L7.89474 10.872V9.6H9.15L12.3079 12.8L13.4211 11.672L11.3763 9.6H14.2105V8H7.89474V6.728ZM13.4211 0H15V4H13.4211V0ZM13.4211 4.8H15V6.4H13.4211V4.8Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CancelIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.47625 0 0 4.4775 0 10C0 15.5225 4.47625 20 10 20C15.5238 20 20 15.5225 20 10C20 4.4775 15.5238 0 10 0ZM14.6337 12.8663C14.8681 13.1006 14.9998 13.4185 14.9998 13.75C14.9998 14.0815 14.8681 14.3994 14.6337 14.6337C14.3994 14.8681 14.0815 14.9998 13.75 14.9998C13.4185 14.9998 13.1006 14.8681 12.8663 14.6337L10 11.7675L7.13375 14.6337C7.01793 14.7502 6.88023 14.8427 6.72857 14.9057C6.5769 14.9688 6.41426 15.0013 6.25 15.0013C6.08574 15.0013 5.9231 14.9688 5.77143 14.9057C5.61977 14.8427 5.48207 14.7502 5.36625 14.6337C5.13191 14.3993 5.00027 14.0815 5.00027 13.75C5.00027 13.4185 5.13191 13.1007 5.36625 12.8663L8.2325 10L5.36625 7.13375C5.13187 6.89936 5.00019 6.58147 5.00019 6.25C5.00019 5.91853 5.13187 5.60064 5.36625 5.36625C5.60064 5.13187 5.91853 5.00019 6.25 5.00019C6.58147 5.00019 6.89936 5.13187 7.13375 5.36625L10 8.2325L12.8663 5.36625C13.1006 5.13187 13.4185 5.00019 13.75 5.00019C14.0815 5.00019 14.3994 5.13187 14.6337 5.36625C14.8681 5.60064 14.9998 5.91853 14.9998 6.25C14.9998 6.58147 14.8681 6.89936 14.6337 7.13375L11.7675 10L14.6337 12.8663Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DoubleOppositeFacingArrowsIcon() {
  return (
    <svg
      width="15"
      height="22"
      viewBox="0 0 15 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 14.6364L7.5 21L14 14.6364M14 7.36364L7.5 1L1 7.36364"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function CancelIcon2() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.42857 0 0 4.42857 0 10C0 15.5714 4.42857 20 10 20C15.5714 20 20 15.5714 20 10C20 4.42857 15.5714 0 10 0ZM10 18.5714C5.28571 18.5714 1.42857 14.7143 1.42857 10C1.42857 5.28571 5.28571 1.42857 10 1.42857C14.7143 1.42857 18.5714 5.28571 18.5714 10C18.5714 14.7143 14.7143 18.5714 10 18.5714Z"
        fill="currentColor  "
      />
      <path
        d="M13.8571 15L10 11.1429L6.14286 15L5 13.8571L8.85714 10L5 6.14286L6.14286 5L10 8.85714L13.8571 5L15 6.14286L11.1429 10L15 13.8571L13.8571 15Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Logo() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 43 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.32 0.959999H7.088C9.944 0.959999 13.016 2.064 13.016 5.448C13.016 7.008 12.32 8.232 10.952 9C12.752 9.672 13.736 11.208 13.736 13.104C13.736 16.704 10.352 18 7.208 18H0.32V0.959999ZM4.76 14.4H7.136C8.288 14.4 9.152 13.92 9.152 12.672C9.152 12.12 8.984 11.688 8.648 11.376C8.288 11.088 7.784 10.944 7.136 10.944H4.76V14.4ZM4.76 7.656H6.656C7.664 7.656 8.456 7.224 8.456 6.12C8.456 4.992 7.688 4.56 6.656 4.56H4.76V7.656Z"
        fill="#76B340"
      />
      <path
        d="M15.1653 11.496C15.1653 7.752 17.8773 4.728 21.7653 4.728C25.9413 4.728 28.3653 7.704 28.3653 11.856V12.672H19.7493C19.9893 13.848 20.6853 14.784 21.9813 14.784C22.8213 14.784 23.5173 14.424 24.0213 13.68L28.1253 14.592C27.1173 17.088 24.4293 18.36 21.8373 18.36C17.9013 18.36 15.1653 15.48 15.1653 11.496ZM21.7653 7.92C20.5173 7.92 19.8933 8.856 19.7013 9.984H23.7333C23.5413 8.88 23.0133 7.92 21.7653 7.92ZM28.49 18L33.194 11.184L29.018 5.088H34.01L35.714 8.256L37.466 5.088H42.338L38.162 11.184L42.866 18H37.634L35.642 14.352L33.602 18H28.49Z"
        fill="#0C8381"
      />
    </svg>
  );
}

export function Compass() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 18.75L10.25 10.25L18.75 6.25L14.75 14.75L6.25 18.75ZM12.5 11.375C12.2016 11.375 11.9155 11.4935 11.7045 11.7045C11.4935 11.9155 11.375 12.2016 11.375 12.5C11.375 12.7984 11.4935 13.0845 11.7045 13.2955C11.9155 13.5065 12.2016 13.625 12.5 13.625C12.7984 13.625 13.0845 13.5065 13.2955 13.2955C13.5065 13.0845 13.625 12.7984 13.625 12.5C13.625 12.2016 13.5065 11.9155 13.2955 11.7045C13.0845 11.4935 12.7984 11.375 12.5 11.375ZM12.5 0C14.1415 0 15.767 0.323322 17.2835 0.951506C18.8001 1.57969 20.1781 2.50043 21.3388 3.66117C22.4996 4.8219 23.4203 6.19989 24.0485 7.71646C24.6767 9.23303 25 10.8585 25 12.5C25 15.8152 23.683 18.9946 21.3388 21.3388C18.9946 23.683 15.8152 25 12.5 25C10.8585 25 9.23303 24.6767 7.71646 24.0485C6.19989 23.4203 4.8219 22.4996 3.66117 21.3388C1.31696 18.9946 0 15.8152 0 12.5C0 9.18479 1.31696 6.00537 3.66117 3.66117C6.00537 1.31696 9.18479 0 12.5 0ZM12.5 2.5C9.84783 2.5 7.3043 3.55357 5.42893 5.42893C3.55357 7.3043 2.5 9.84783 2.5 12.5C2.5 15.1522 3.55357 17.6957 5.42893 19.5711C7.3043 21.4464 9.84783 22.5 12.5 22.5C15.1522 22.5 17.6957 21.4464 19.5711 19.5711C21.4464 17.6957 22.5 15.1522 22.5 12.5C22.5 9.84783 21.4464 7.3043 19.5711 5.42893C17.6957 3.55357 15.1522 2.5 12.5 2.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

// process

export function MeasureAndIterate() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9545 3.9269e-05C10.7173 -0.00664424 8.56023 0.840034 6.91626 2.37019C5.27229 3.90035 4.263 6.00077 4.09091 8.25002H0L5.45455 13.75L10.9091 8.25002H6.85909C7.02675 6.73797 7.74103 5.34121 8.86546 4.32662C9.9899 3.31203 11.4456 2.75076 12.9545 2.75003C14.582 2.75003 16.1428 3.40193 17.2936 4.56231C18.4444 5.72269 19.0909 7.2965 19.0909 8.93752C19.0909 10.5785 18.4444 12.1524 17.2936 13.3127C16.1428 14.4731 14.582 15.125 12.9545 15.125H1.36364V17.875H12.9545C15.3053 17.875 17.5598 16.9334 19.2221 15.2573C20.8843 13.5812 21.8182 11.3079 21.8182 8.93752C21.8182 6.56715 20.8843 4.29387 19.2221 2.61777C17.5598 0.941664 15.3053 3.9269e-05 12.9545 3.9269e-05ZM24.5455 11V15.125H21.1364C20.3045 16.2428 19.256 17.1784 18.0545 17.875H24.5455V22L30 16.5L24.5455 11Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Launch() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.10627 13.1687L7.45505 15.0108C8.00531 13.9083 8.60467 12.8413 9.25314 11.8098C9.90161 10.7783 10.6175 9.77522 11.4009 8.80058L8.67626 8.27832C8.49403 8.23213 8.31771 8.23746 8.14731 8.2943C7.97691 8.35115 7.82307 8.44766 7.6858 8.58385L3.10627 13.1687ZM8.86086 16.1371L13.8841 21.1571C15.2864 20.5236 16.6975 19.7183 18.1176 18.7412C19.5376 17.7642 20.9031 16.6196 22.2143 15.3075C24.1254 13.3949 25.5856 11.355 26.595 9.18783C27.6044 7.02063 28.1718 4.51829 28.2972 1.68081C25.462 1.80634 22.9651 2.37419 20.8067 3.38436C18.6506 4.39454 16.6165 5.85591 14.7042 7.76849C13.3942 9.08065 12.2511 10.4526 11.2749 11.8844C10.2986 13.3162 9.49395 14.7337 8.86086 16.1371ZM18.0554 11.9181C17.5348 11.3971 17.2744 10.7718 17.2744 10.0423C17.2744 9.31277 17.5348 8.68688 18.0554 8.16463C18.5761 7.64237 19.2092 7.38183 19.9547 7.38302C20.7002 7.3842 21.3327 7.64474 21.8522 8.16463C22.3717 8.68452 22.632 9.3104 22.6332 10.0423C22.6344 10.7741 22.374 11.3994 21.8522 11.9181C21.3315 12.4392 20.6984 12.6997 19.9529 12.6997C19.2074 12.6997 18.5755 12.4392 18.0572 11.9181M16.8165 26.9268L21.3978 22.342C21.5339 22.2046 21.6309 22.0507 21.6889 21.8801C21.7457 21.7096 21.7516 21.5331 21.7066 21.3508L21.183 18.624C20.2091 19.408 19.2068 20.1227 18.1761 20.7681C17.1454 21.4135 16.0792 22.0116 14.9776 22.5623L16.8165 26.9268ZM29.9551 0.0447531C30.1539 3.30857 29.6924 6.31067 28.5706 9.05105C27.45 11.7926 25.7045 14.3494 23.3343 16.7215L23.0255 17.0288L22.7184 17.3361L23.4355 20.9813C23.5313 21.4597 23.5136 21.9234 23.3822 22.3722C23.2497 22.821 23.0107 23.2183 22.6651 23.5641L16.2005 30L13.2576 23.0632L6.93142 16.7322L0 13.7531L6.42022 7.31729C6.76576 6.97149 7.16454 6.72694 7.61658 6.58364C8.06861 6.44035 8.53367 6.41666 9.01174 6.51259L12.7215 7.26222C12.8351 7.14853 12.9316 7.04609 13.0108 6.95491C13.0901 6.86372 13.1872 6.76128 13.3019 6.64759C15.6734 4.27434 18.2264 2.53111 20.9611 1.4179C23.6958 0.304698 26.6926 -0.153018 29.9551 0.0447531ZM2.97847 21.9618C3.67309 21.2679 4.51682 20.9244 5.50964 20.9315C6.50246 20.9386 7.34618 21.2904 8.04081 21.9867C8.73543 22.6831 9.08096 23.5274 9.07741 24.5198C9.07386 25.5146 8.72478 26.359 8.03016 27.053C7.42665 27.6569 6.45927 28.1739 5.12801 28.6038C3.79675 29.0336 2.25545 29.3309 0.504104 29.4955C0.668588 27.7428 0.971524 26.2003 1.41291 24.868C1.8543 23.5357 2.37615 22.567 2.97847 21.9618ZM4.24583 23.2533C3.90384 23.5955 3.58493 24.1533 3.2891 24.9266C2.99326 25.7 2.79801 26.4976 2.70334 27.3194C3.52458 27.2235 4.32156 27.0234 5.09429 26.719C5.86582 26.4158 6.42259 26.0931 6.76457 25.7509C7.11958 25.3956 7.30063 24.9722 7.30773 24.4808C7.31364 23.9881 7.1391 23.5641 6.7841 23.2089C6.4291 22.8536 6.00605 22.6836 5.51496 22.699C5.02388 22.7133 4.60083 22.898 4.24583 23.2533Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Build() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 29 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 13L4 31M17.5 13L25 31M14.5 4V1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 13C16.9853 13 19 10.9853 19 8.5C19 6.01472 16.9853 4 14.5 4C12.0147 4 10 6.01472 10 8.5C10 10.9853 12.0147 13 14.5 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 17.5C3.985 22.036 8.92 25 14.5 25C20.08 25 25.015 22.036 28 17.5M14.5 23.5V26.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ChevronRight() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_45_2252)">
        {/* Background Circle */}
        <path
          d="M24 40C18.6957 40 13.6086 37.8929 9.85786 34.1421C6.10714 30.3914 4 25.3043 4 20C4 17.3736 4.51731 14.7728 5.52241 12.3463C6.5275 9.91982 8.00069 7.71504 9.85786 5.85786C13.6086 2.10714 18.6957 0 24 0C29.3043 0 34.3914 2.10714 38.1421 5.85786C41.8929 9.60859 44 14.6957 44 20C44 22.6264 43.4827 25.2272 42.4776 27.6537C41.4725 30.0802 39.9993 32.285 38.1421 34.1421C36.285 35.9993 34.0802 37.4725 31.6537 38.4776C29.2272 39.4827 26.6264 40 24 40Z"
          fill="#FFFFFF"
        />

        {/* Chevron Arrow */}
        <path
          d="M17.2 10.8L26.4 20L17.2 29.2L20 32L32 20L20 8L17.2 10.8Z"
          fill="#77b441"
        />
      </g>

      <defs>
        <filter
          id="filter0_d_45_2252"
          x="0"
          y="0"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_45_2252"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_45_2252"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function Feedback() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.20478 2.22725C9.54127 2.09281 9.90796 2.05231 10.2657 2.11008C10.6234 2.16785 10.9587 2.32172 11.2358 2.55525L11.3618 2.67025L16.0858 7.39425C16.3423 7.65052 16.5244 7.97172 16.6124 8.32348C16.7005 8.67524 16.6913 9.04433 16.5858 9.39125L16.5288 9.55125L14.1638 15.4643C14.0311 15.7953 13.8123 16.0848 13.5301 16.3028C13.2479 16.5208 12.9126 16.6594 12.5588 16.7043L7.47978 17.3393C7.34911 17.3546 7.21244 17.3733 7.06978 17.3953L6.62578 17.4673L6.39378 17.5093L5.67078 17.6493L5.17578 17.7553L4.43078 17.9223L3.47578 18.1503L1.92378 18.5463L1.27778 18.7203C1.11475 18.7651 0.943082 18.7683 0.778508 18.7295C0.613933 18.6908 0.46172 18.6113 0.335825 18.4985C0.20993 18.3856 0.114381 18.2429 0.0579391 18.0836C0.00149727 17.9242 -0.0140312 17.7532 0.0127771 17.5863L0.0467771 17.4403L0.341777 16.3283L0.605777 15.2803L0.833777 14.3253L1.00078 13.5803L1.10578 13.0843L1.24678 12.3623L1.32678 11.9053L1.39078 11.4773L2.05078 6.19725C2.09235 5.8714 2.21354 5.5608 2.40365 5.29291C2.59376 5.02502 2.84692 4.80807 3.14078 4.66125L3.29178 4.59225L9.20478 2.22725ZM9.94678 4.08425L4.03478 6.44925L3.45078 11.1213L3.40278 11.5173C3.30462 12.2529 3.17618 12.9842 3.01778 13.7093L2.84678 14.4953L6.13478 11.2073C6.02079 10.782 6.05031 10.331 6.21877 9.9242C6.38724 9.51742 6.68522 9.1776 7.06651 8.95744C7.4478 8.73728 7.89108 8.64909 8.32759 8.70655C8.76411 8.76401 9.16947 8.9639 9.4808 9.27523C9.79212 9.58656 9.99202 9.99192 10.0495 10.4284C10.1069 10.865 10.0187 11.3082 9.79859 11.6895C9.57843 12.0708 9.23861 12.3688 8.83183 12.5373C8.42505 12.7057 7.97405 12.7352 7.54878 12.6213L4.26078 15.9093L4.65278 15.8223L5.43678 15.6573C5.92537 15.5575 6.41655 15.4708 6.90978 15.3973L12.3068 14.7213L14.6718 8.80925L9.94678 4.08425ZM12.3098 0.790251C12.4818 0.617927 12.7109 0.514312 12.9539 0.498846C13.1969 0.483381 13.4373 0.557128 13.6298 0.706251L13.7238 0.790251L17.9658 5.03225C18.147 5.21179 18.2528 5.45382 18.2615 5.7088C18.2701 5.96378 18.181 6.21242 18.0123 6.40383C17.8436 6.59524 17.6082 6.71495 17.3542 6.73845C17.1001 6.76196 16.8467 6.68747 16.6458 6.53025L16.5518 6.44625L12.3098 2.20425C12.1223 2.01672 12.017 1.76242 12.017 1.49725C12.017 1.23209 12.1223 0.977779 12.3098 0.790251Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function XCircle() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.42857 0 0 4.42857 0 10C0 15.5714 4.42857 20 10 20C15.5714 20 20 15.5714 20 10C20 4.42857 15.5714 0 10 0ZM10 18.5714C5.28571 18.5714 1.42857 14.7143 1.42857 10C1.42857 5.28571 5.28571 1.42857 10 1.42857C14.7143 1.42857 18.5714 5.28571 18.5714 10C18.5714 14.7143 14.7143 18.5714 10 18.5714Z"
        fill="currentColor"
      />
      <path
        d="M13.8571 15L10 11.1429L6.14286 15L5 13.8571L8.85714 10L5 6.14286L6.14286 5L10 8.85714L13.8571 5L15 6.14286L11.1429 10L15 13.8571L13.8571 15Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function SendArrow() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 5.5L-4.66482e-07 10.8359L5.33594 5.5L0 0.164062L16 5.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function PlanAndDesign() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.07 1.33099C5.15573 1.1456 5.17856 0.937286 5.13504 0.737726C5.09151 0.538166 4.984 0.35828 4.82887 0.225425C4.67373 0.0925695 4.47945 0.0140138 4.27557 0.00170462C4.07169 -0.0106046 3.86937 0.0440063 3.69938 0.157232L3.69562 0.159107L3.69 0.162856L3.67313 0.174107L3.61687 0.211607L3.42562 0.352233C3.21347 0.512987 3.00709 0.681219 2.80687 0.856613C2.33437 1.26912 1.725 1.88225 1.29187 2.6135C0.913294 3.21949 0.609816 3.86926 0.388125 4.54852C0.163125 5.22165 0 5.95103 0 6.56229C0 8.16168 0.5925 9.52482 1.51688 10.3611L1.39687 10.4998C0.871875 11.1448 0.56625 11.9811 0.375 12.8061C8.3819e-08 14.4374 0 16.3986 0 17.7655V17.8124C0 23.0381 0.710625 26.0025 1.4925 27.6975C1.88625 28.5506 2.30437 29.0944 2.66625 29.4356C2.84812 29.6081 3.01313 29.7262 3.15 29.8069C3.22989 29.8549 3.31324 29.8969 3.39937 29.9325C3.39937 29.9325 3.61125 30 3.75 30C3.88875 30 4.10062 29.9325 4.10062 29.9325C4.18676 29.8969 4.27011 29.8549 4.35 29.8069C4.52423 29.701 4.68643 29.5765 4.83375 29.4356C5.19563 29.0925 5.61375 28.5506 6.0075 27.6975C6.78937 26.0025 7.5 23.0381 7.5 17.8124V17.7655C7.5 16.3968 7.5 14.4374 7.125 12.8061C6.93375 11.9811 6.62813 11.1448 6.10313 10.4998L5.98312 10.3611C6.9075 9.52482 7.5 8.16168 7.5 6.56229C7.5 5.2554 7.23563 4.35727 6.7575 3.63914C6.54476 3.33073 6.29961 3.04598 6.02625 2.78976L5.7075 2.48975C5.59313 2.38288 5.48813 2.28538 5.35125 2.1485C5.07 1.86725 5.03812 1.64224 5.03812 1.52412C5.03738 1.45838 5.04817 1.39301 5.07 1.33099ZM5.625 6.56229C5.625 8.56856 4.47375 9.37294 3.75375 9.37481H3.75C3.02813 9.37481 1.875 8.57231 1.875 6.56229C1.875 6.23791 1.9725 5.72416 2.1675 5.1429C2.34475 4.59397 2.58976 4.06929 2.89688 3.58101C3.06 3.30538 3.27188 3.03726 3.50063 2.79163C3.62813 3.02163 3.80312 3.24976 4.02562 3.47601C4.1625 3.61289 4.34062 3.77789 4.4925 3.92039L4.725 4.13789C4.92188 4.32914 5.07375 4.49602 5.19562 4.68165C5.42062 5.01728 5.625 5.5254 5.625 6.56229ZM2.20312 13.228C2.36437 12.5267 2.58562 12.0092 2.85 11.6848C2.95283 11.545 3.08818 11.4323 3.24434 11.3565C3.4005 11.2807 3.57277 11.2441 3.74625 11.2498H3.75C4.14375 11.2498 4.41375 11.3961 4.65 11.6848C4.91437 12.0092 5.1375 12.5267 5.29687 13.228C5.62125 14.6305 5.625 16.393 5.625 17.8124C5.625 22.8993 4.92938 25.56 4.305 26.9118C4.09875 27.3562 3.90563 27.6525 3.75 27.8494C3.52771 27.5605 3.34135 27.2457 3.195 26.9118C2.57063 25.56 1.875 22.8993 1.875 17.8124C1.875 16.393 1.87875 14.6305 2.20312 13.228ZM13.125 20.6249C11.7844 20.6249 10.5075 20.3437 9.35625 19.8374C9.38125 19.1699 9.39375 18.4761 9.39375 17.7561C10.5295 18.4074 11.8158 18.75 13.125 18.7499V14.9999C13.125 14.0053 13.5201 13.0515 14.2234 12.3482C14.9266 11.6449 15.8804 11.2498 16.875 11.2498H20.625C20.6252 9.91805 20.2707 8.61023 19.5981 7.46079C18.9255 6.31135 17.9589 5.36174 16.7978 4.70957C15.6366 4.05739 14.3227 3.72616 12.9912 3.74992C11.6596 3.77368 10.3584 4.15158 9.22125 4.84477C9.10435 4.21561 8.89056 3.60838 8.5875 3.04476C10.0149 2.25527 11.6235 1.85187 13.2545 1.8744C14.8855 1.89694 16.4824 2.34464 17.8874 3.17326C19.2925 4.00189 20.457 5.18276 21.2659 6.59921C22.0748 8.01566 22.5002 9.61866 22.5 11.2498H26.25C27.2446 11.2498 28.1984 11.6449 28.9016 12.3482C29.6049 13.0515 30 14.0053 30 14.9999V24.375C30 25.3695 29.6049 26.3234 28.9016 27.0266C28.1984 27.7299 27.2446 28.125 26.25 28.125H16.875C15.8804 28.125 14.9266 27.7299 14.2234 27.0266C13.5201 26.3234 13.125 25.3695 13.125 24.375V20.6249ZM22.3125 13.1248C21.9428 14.9255 21.0529 16.5781 19.7531 17.878C18.4533 19.1778 16.8007 20.0677 15 20.4374V24.375C15 24.8722 15.1975 25.3492 15.5492 25.7008C15.9008 26.0524 16.3777 26.25 16.875 26.25H26.25C26.7473 26.25 27.2242 26.0524 27.5758 25.7008C27.9275 25.3492 28.125 24.8722 28.125 24.375V14.9999C28.125 14.5026 27.9275 14.0257 27.5758 13.674C27.2242 13.3224 26.7473 13.1248 26.25 13.1248H22.3125ZM20.3888 13.1248H16.875C16.3777 13.1248 15.9008 13.3224 15.5492 13.674C15.1975 14.0257 15 14.5026 15 14.9999V18.5136C16.2969 18.177 17.4803 17.5 18.4277 16.5526C19.3751 15.6051 20.0521 14.4217 20.3888 13.1248Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Youtube() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8838 15.9999L12.5117 20.8837V11.1162L20.8838 15.9999Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function LinkedIn() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2884 11.213C17.6541 11.213 17.1845 11.373 16.8168 11.5751C16.7579 11.3655 16.5642 11.2121 16.336 11.258H13.5444C13.2684 11.2121 13.0449 11.4357 13.13 11.7257V22.0163C13.0449 22.2783 13.2684 22.5028 13.5444 22.4841H16.336C16.612 22.5028 16.8355 22.2783 16.8355 22.0023L16.8346 15.783C16.8337 15.7802 16.8234 15.4827 17.0114 15.2778C17.162 15.1151 17.4212 15.0318 17.7795 15.0318C18.3763 15.0318 18.642 15.276 18.7412 15.8223V22.0023C18.643 22.2783 18.8665 22.5028 19.1425 22.4841H22.0847C22.3607 22.5028 22.5843 22.2783 22.4851 22.0023V15.6146C22.5833 12.3665 20.2698 11.213 18.2884 11.213ZM21.5842 21.5486H19.6421V15.8223C19.6421 14.7175 18.9283 14.0327 17.7804 14.0327C17.1312 14.0327 16.626 14.2235 16.278 14.5996C15.7943 15.1235 15.8317 15.7877 15.9356 15.9355V21.5486H14.044V12.2122H15.8364V12.5265C15.8357 12.6201 15.8614 12.7121 15.9106 12.7918C15.9597 12.8715 16.0304 12.9357 16.1144 12.977C16.1985 13.0183 16.2924 13.0351 16.3856 13.0254C16.4787 13.0157 16.5672 12.98 16.641 12.9222L16.7719 12.8212C17.1508 12.5228 17.5428 12.2131 18.2893 12.2131C19.0621 12.2131 21.5851 12.4591 21.5851 15.6156L21.5842 21.5486ZM10.3225 6.54858C9.27287 6.54858 8.41968 7.40177 8.41968 8.45142C8.41968 9.50106 9.27287 10.3542 10.3225 10.3542C11.3722 10.3542 12.2253 9.50106 12.2253 8.45142C12.2253 7.40177 11.3722 6.54858 10.3225 6.54858ZM10.3225 9.35512C9.82482 9.35512 9.41881 8.94911 9.41881 8.45142C9.41881 7.95372 9.82482 7.54771 10.3225 7.54771C10.8202 7.54771 11.2262 7.95372 11.2262 8.45142C11.2262 8.94911 10.8202 9.35512 10.3225 9.35512ZM11.6584 11.2121H8.88182C8.60585 11.2121 8.38226 11.4357 8.45149 11.7257V22.0163C8.38226 22.2783 8.60585 22.5028 8.88182 22.4841H11.6584C11.9344 22.5028 12.158 22.2783 12.158 22.0023V11.7117C12.158 11.5792 12.1054 11.4521 12.0117 11.3584C11.918 11.2647 11.7909 11.2121 11.6584 11.2121ZM11.258 21.5486H9.38138V12.2122H11.258V21.5486Z"
        fill="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M15 0C6.7282 0 0 6.7282 0 15C0 23.2718 6.7282 30 15 30C23.2718 30 30 23.2718 30 15C30 6.7282 23.2718 0 15 0ZM15 29.0009C7.28015 29.0009 0.999127 22.7198 0.999127 15C0.999127 7.28015 7.28015 0.999127 15 0.999127C22.7198 0.999127 29.0009 7.28015 29.0009 15C29.0009 22.7198 22.7198 29.0009 15 29.0009Z"
        fill="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
export function TwitterX() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 23.5L14.791 17.2105M14.791 17.2105L8.5 8.5H12.6655L17.2105 14.791L23.5 8.5M14.791 17.2105L19.333 23.5H23.5L17.209 14.7895"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 16C31 24.2845 24.2845 31 16 31C7.7155 31 1 24.2845 1 16C1 7.7155 7.7155 1 16 1C24.2845 1 31 7.7155 31 16Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Facebook() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C12.0333 0 9.13319 0.879734 6.66645 2.52795C4.19971 4.17618 2.27713 6.51886 1.14181 9.25975C0.00649901 12.0006 -0.290551 15.0166 0.288228 17.9263C0.867006 20.8361 2.29562 23.5088 4.3934 25.6066C6.49119 27.7044 9.16393 29.133 12.0736 29.7118C14.9834 30.2906 17.9994 29.9935 20.7403 28.8582C23.4811 27.7229 25.8238 25.8003 27.472 23.3335C29.1203 20.8668 30 17.9667 30 15C29.9953 11.0232 28.4135 7.21059 25.6014 4.39856C22.7894 1.58652 18.9768 0.00467037 15 0ZM15.8824 28.2059V18.2353H19.7059C19.9399 18.2353 20.1643 18.1423 20.3298 17.9769C20.4953 17.8114 20.5882 17.587 20.5882 17.3529C20.5882 17.1189 20.4953 16.8945 20.3298 16.729C20.1643 16.5635 19.9399 16.4706 19.7059 16.4706H15.8824V12.6471C15.8824 11.945 16.1612 11.2717 16.6577 10.7753C17.1541 10.2789 17.8274 10 18.5294 10H20.8824C21.1164 10 21.3408 9.90703 21.5063 9.74156C21.6717 9.57609 21.7647 9.35166 21.7647 9.11764C21.7647 8.88363 21.6717 8.6592 21.5063 8.49373C21.3408 8.32825 21.1164 8.23529 20.8824 8.23529H18.5294C17.3593 8.23529 16.2372 8.7001 15.4098 9.52747C14.5825 10.3548 14.1177 11.477 14.1177 12.6471V16.4706H10.2941C10.0601 16.4706 9.83568 16.5635 9.6702 16.729C9.50473 16.8945 9.41177 17.1189 9.41177 17.3529C9.41177 17.587 9.50473 17.8114 9.6702 17.9769C9.83568 18.1423 10.0601 18.2353 10.2941 18.2353H14.1177V28.2059C10.6915 27.977 7.48843 26.4254 5.18486 23.879C2.88129 21.3325 1.65755 17.9905 1.77208 14.5586C1.8866 11.1267 3.33042 7.8737 5.79863 5.48648C8.26684 3.09926 11.5662 1.76474 15 1.76474C18.4338 1.76474 21.7332 3.09926 24.2014 5.48648C26.6696 7.8737 28.1134 11.1267 28.2279 14.5586C28.3425 17.9905 27.1187 21.3325 24.8151 23.879C22.5116 26.4254 19.3085 27.977 15.8824 28.2059Z"
        fill="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function Linker() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 19 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 0C17.56 0 18.0333 0.193333 18.42 0.58C18.8067 0.966667 19 1.43967 19 1.999C19 2.55833 18.8067 3.03167 18.42 3.419C18.0333 3.80633 17.56 4 17 4C16.5347 4 16.1223 3.85833 15.763 3.575C15.4037 3.29167 15.171 2.93333 15.065 2.5L0 2.5V1.5L15.065 1.5C15.1717 1.06667 15.4043 0.708333 15.763 0.425C16.1217 0.141667 16.534 0 17 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function UploadIcon() {
  return (
    <svg
      width="29"
      height="30"
      viewBox="0 0 29 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.58688 15.7907H4.73649C3.4803 15.7907 2.27555 15.2917 1.38729 14.4034C0.499022 13.5152 0 12.3104 0 11.0542C0 9.79802 0.499022 8.59327 1.38729 7.70501C2.27555 6.81674 3.4803 6.31772 4.73649 6.31772C5.17857 6.31772 5.3996 6.31772 5.55275 6.28614C6.02324 6.19141 6.24743 6.04774 6.52531 5.65619C6.61688 5.52988 6.74634 5.24254 7.00369 4.66784C7.62647 3.27758 8.63813 2.09716 9.91669 1.26893C11.1952 0.440689 12.6861 0 14.2095 0C15.7329 0 17.2237 0.440689 18.5023 1.26893C19.7808 2.09716 20.7925 3.27758 21.4153 4.66784C21.6726 5.24254 21.8021 5.52831 21.8936 5.65619C22.1731 6.04774 22.3957 6.19299 22.8662 6.28772C23.0209 6.31772 23.242 6.31772 23.6825 6.31772C24.9387 6.31772 26.1434 6.81674 27.0317 7.70501C27.9199 8.59327 28.419 9.79802 28.419 11.0542C28.419 12.3104 27.9199 13.5152 27.0317 14.4034C26.1434 15.2917 24.9387 15.7907 23.6825 15.7907H21.8321L16.4419 10.4006L14.2095 8.16811L11.977 10.4006L6.58688 15.7907Z"
        fill="#AAAAAA"
      />
      <path
        d="M14.2094 14.2115L13.0932 13.0952L14.2094 11.979L15.3256 13.0952L14.2094 14.2115ZM15.7882 28.4209C15.7882 28.8397 15.6219 29.2413 15.3258 29.5374C15.0297 29.8334 14.6281 29.9998 14.2094 29.9998C13.7907 29.9998 13.3891 29.8334 13.093 29.5374C12.7969 29.2413 12.6306 28.8397 12.6306 28.4209H15.7882ZM6.77783 19.4106L13.0932 13.0952L15.3256 15.3277L9.0103 21.643L6.77783 19.4106ZM15.3256 13.0952L21.6409 19.4106L19.4085 21.643L13.0932 15.3277L15.3256 13.0952ZM15.7882 14.2115V28.4209H12.6306V14.2115H15.7882Z"
        fill="#AAAAAA"
      />
    </svg>
  );
}

export function UpsideDownBulbIcon() {
  return (
    <svg
      width="17"
      height="25"
      viewBox="0 0 17 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.80006 1.66667L10.2 1.66667C10.4255 1.66667 10.6417 1.57887 10.8011 1.42259C10.9605 1.26631 11.05 1.05435 11.05 0.833332C11.05 0.612319 10.9605 0.400356 10.8011 0.244077C10.6417 0.0877966 10.4255 -5.74764e-07 10.2 -5.94472e-07L6.80006 -8.91708e-07C6.57462 -9.11415e-07 6.35842 0.0877962 6.19902 0.244077C6.03962 0.400355 5.95006 0.612319 5.95006 0.833331C5.95006 1.05435 6.03962 1.26631 6.19902 1.42259C6.35842 1.57887 6.57462 1.66667 6.80006 1.66667ZM5.95006 4.16666L11.05 4.16666C11.2755 4.16666 11.4917 4.07887 11.6511 3.92259C11.8105 3.76631 11.9 3.55434 11.9 3.33333C11.9 3.11232 11.8105 2.90035 11.6511 2.74407C11.4917 2.58779 11.2755 2.5 11.05 2.5L5.95006 2.5C5.72463 2.5 5.50843 2.58779 5.34903 2.74407C5.18962 2.90035 5.10007 3.11232 5.10007 3.33333C5.10007 3.55434 5.18962 3.7663 5.34903 3.92259C5.50843 4.07887 5.72463 4.16666 5.95006 4.16666ZM2.47465 22.5682C4.07211 24.1364 6.21197 25 8.50004 25C9.61702 25.0026 10.7235 24.7888 11.756 24.371C12.7884 23.9531 13.7265 23.3394 14.5163 22.565C15.3062 21.7907 15.9322 20.871 16.3584 19.8588C16.7846 18.8465 17.0026 17.7617 17 16.6667C17 14.2385 16.0506 11.9672 14.3969 10.4354L14.1652 10.2224C13.2085 9.3453 11.9 8.14374 11.9 7.08333L11.9 5.83333C11.9 5.61231 11.8105 5.40035 11.6511 5.24407C11.4917 5.08779 11.2755 5 11.05 5L9.77503 5C9.66232 5 9.55422 5.04389 9.47452 5.12203C9.39481 5.20017 9.35004 5.30615 9.35004 5.41666L9.35004 11.5198C9.35001 11.604 9.37604 11.6863 9.42469 11.7558C9.47335 11.8252 9.54234 11.8786 9.62257 11.9088C10.1134 12.1051 10.5797 12.3559 11.0123 12.6562C11.1095 12.7171 11.1931 12.7967 11.2579 12.8903C11.3227 12.9838 11.3675 13.0893 11.3894 13.2004C11.4113 13.3114 11.4099 13.4257 11.3853 13.5361C11.3607 13.6466 11.3135 13.7511 11.2464 13.8431C11.1793 13.9351 11.0939 14.0128 10.9952 14.0714C10.8965 14.13 10.7867 14.1682 10.6725 14.1839C10.5582 14.1995 10.4419 14.1922 10.3307 14.1624C10.2194 14.1326 10.1155 14.0809 10.0252 14.0104C9.63213 13.7375 8.8751 13.3333 8.50004 13.3333C8.12498 13.3333 7.36796 13.7385 6.97377 14.0104C6.79023 14.1235 6.56954 14.1636 6.35684 14.1225C6.14415 14.0813 5.95552 13.9621 5.82956 13.7891C5.7036 13.6161 5.64983 13.4024 5.67924 13.1919C5.70865 12.9813 5.81902 12.7897 5.98778 12.6562C6.42048 12.3565 6.88676 12.1062 7.37752 11.9104C7.45774 11.8802 7.52674 11.8268 7.57539 11.7574C7.62405 11.6879 7.65008 11.6056 7.65005 11.5213L7.65005 5.41666C7.65005 5.30615 7.60527 5.20017 7.52557 5.12203C7.44587 5.04389 7.33777 5 7.22505 5L5.95006 5C5.72463 5 5.50843 5.08779 5.34903 5.24407C5.18962 5.40035 5.10007 5.61231 5.10007 5.83333L5.10007 7.08333C5.10007 8.11874 3.80595 9.31926 2.86087 10.1963L2.60003 10.4391C0.898977 12.0312 0.000107757 14.187 0.00010754 16.6666C-0.00551923 17.7618 0.210267 18.8473 0.634999 19.8602C1.05973 20.8732 1.68499 21.7935 2.47465 22.5682Z"
        fill="black"
      />
    </svg>
  );
}

export function InfoIcon({
  color = "black",
  width = 16,
  height = 15,
}: {
  color?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14.5C11.866 14.5 15 11.366 15 7.5C15 3.63401 11.866 0.5 8 0.5C4.13401 0.5 1 3.63401 1 7.5C1 11.366 4.13401 14.5 8 14.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.3V7.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4.70001H8.007"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PresentIcon({
  color = "black",
  width = 17,
  height = 17,
}: {
  color?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7001 7.5V14H2.30008V7.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 4.25H1V7.5H14V4.25Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14V4.25"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49992 4.25H4.57492C4.14394 4.25 3.73062 4.0788 3.42587 3.77405C3.12113 3.4693 2.94992 3.05598 2.94992 2.625C2.94992 2.19402 3.12113 1.7807 3.42587 1.47595C3.73062 1.1712 4.14394 1 4.57492 1C6.84992 1 7.49992 4.25 7.49992 4.25Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 4.25H10.425C10.856 4.25 11.2693 4.0788 11.574 3.77405C11.8788 3.4693 12.05 3.05598 12.05 2.625C12.05 2.19402 11.8788 1.7807 11.574 1.47595C11.2693 1.1712 10.856 1 10.425 1C8.15 1 7.5 4.25 7.5 4.25Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PromotionPlusIcon() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="34" height="34" rx="17" fill="#0C8381" />
      <path
        d="M17 10V24"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 17H24"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChatInputPlus() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
        stroke="#AAAAAA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 5.80005V12.2"
        stroke="#AAAAAA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.80005 9H12.2"
        stroke="#AAAAAA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SmileFaceIcon({
  color = "black",
  width = 16,
  height = 15,
}: {
  color?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14.5C11.866 14.5 15 11.366 15 7.5C15 3.63401 11.866 0.5 8 0.5C4.13401 0.5 1 3.63401 1 7.5C1 11.366 4.13401 14.5 8 14.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.20001 8.89999C5.20001 8.89999 6.25001 10.3 8.00001 10.3C9.75001 10.3 10.8 8.89999 10.8 8.89999"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.89999 5.39999H5.90699"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1 5.39999H10.107"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LocationIcon() {
  return (
    <svg
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
        stroke="#AAAAAA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 5.80005V12.2"
        stroke="#AAAAAA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.80005 9H12.2"
        stroke="#AAAAAA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 1.5V15.5"
        stroke="#AAAAAA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 8.5H15"
        stroke="#AAAAAA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.5V15.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 8.5H15"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GoogleIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3444 6.9332H15.7V6.9H8.5V10.1H13.0212C12.3616 11.9628 10.5892 13.3 8.5 13.3C5.8492 13.3 3.7 11.1508 3.7 8.5C3.7 5.8492 5.8492 3.7 8.5 3.7C9.7236 3.7 10.8368 4.1616 11.6844 4.9156L13.9472 2.6528C12.5184 1.3212 10.6072 0.5 8.5 0.5C4.082 0.5 0.5 4.082 0.5 8.5C0.5 12.918 4.082 16.5 8.5 16.5C12.918 16.5 16.5 12.918 16.5 8.5C16.5 7.9636 16.4448 7.44 16.3444 6.9332Z"
        fill="#FFC107"
      />
      <path
        d="M1.42236 4.7764L4.05076 6.704C4.76196 4.9432 6.48436 3.7 8.49996 3.7C9.72356 3.7 10.8368 4.1616 11.6844 4.9156L13.9472 2.6528C12.5184 1.3212 10.6072 0.5 8.49996 0.5C5.42716 0.5 2.76236 2.2348 1.42236 4.7764Z"
        fill="#FF3D00"
      />
      <path
        d="M8.49993 16.5C10.5663 16.5 12.4439 15.7092 13.8635 14.4232L11.3875 12.328C10.5575 12.9596 9.54296 13.3011 8.49993 13.3C6.41913 13.3 4.65233 11.9732 3.98673 10.1216L1.37793 12.1316C2.70193 14.7224 5.39073 16.5 8.49993 16.5Z"
        fill="#4CAF50"
      />
      <path
        d="M16.3444 6.9331H15.7V6.8999H8.5V10.0999H13.0212C12.7057 10.9865 12.1373 11.7612 11.3864 12.3283L11.3876 12.3275L13.8636 14.4227C13.6884 14.5819 16.5 12.4999 16.5 8.4999C16.5 7.9635 16.4448 7.4399 16.3444 6.9331Z"
        fill="#1976D2"
      />
    </svg>
  );
}

export function CancleIcon3() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 1L1 21"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1L21 21"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CameraIcon() {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 17C23 17.5304 22.7893 18.0391 22.4142 18.4142C22.0391 18.7893 21.5304 19 21 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V6C1 5.46957 1.21071 4.96086 1.58579 4.58579C1.96086 4.21071 2.46957 4 3 4H7L9 1H15L17 4H21C21.5304 4 22.0391 4.21071 22.4142 4.58579C22.7893 4.96086 23 5.46957 23 6V17Z"
        stroke="#AAAAAA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15Z"
        stroke="#AAAAAA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FeedbackReplyIcon() {
  return (
    <svg
      width="25"
      height="17"
      viewBox="0 0 25 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.51453 0.323733C9.72734 0.531289 9.84688 0.812639 9.84688 1.10598C9.84688 1.39933 9.72734 1.68068 9.51453 1.88824L3.87794 7.37875H16.2875C17.7315 7.37875 19.874 7.79201 21.6862 9.0628C23.5575 10.3764 25 12.5534 25 15.8654C25 16.159 24.8803 16.4406 24.6672 16.6482C24.454 16.8558 24.165 16.9724 23.8636 16.9724C23.5622 16.9724 23.2731 16.8558 23.06 16.6482C22.8469 16.4406 22.7272 16.159 22.7272 15.8654C22.7272 13.2737 21.6438 11.7623 20.3589 10.8605C19.0149 9.91737 17.3679 9.59267 16.2875 9.59267H3.87794L9.51453 15.0832C9.62618 15.1845 9.71574 15.3067 9.77785 15.4425C9.83996 15.5783 9.87336 15.7249 9.87605 15.8735C9.87874 16.0221 9.85067 16.1698 9.79352 16.3076C9.73636 16.4455 9.65129 16.5707 9.54338 16.6758C9.43547 16.7809 9.30693 16.8638 9.16542 16.9194C9.02392 16.9751 8.87236 17.0025 8.71977 16.9998C8.56718 16.9972 8.4167 16.9647 8.2773 16.9042C8.13791 16.8437 8.01245 16.7564 7.90841 16.6477L0.332347 9.26796C0.119535 9.0604 0 8.77905 0 8.48571C0 8.19236 0.119535 7.91101 0.332347 7.70346L7.90841 0.323733C8.12148 0.116436 8.41032 0 8.71147 0C9.01262 0 9.30145 0.116436 9.51453 0.323733Z"
        fill="#AAAAAA"
      />
    </svg>
  );
}
export function GrayCancleIcon() {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.442 0C6.47773 0 0.942017 5.53571 0.942017 12.5C0.942017 19.4643 6.47773 25 13.442 25C20.4063 25 25.942 19.4643 25.942 12.5C25.942 5.53571 20.4063 0 13.442 0ZM13.442 23.2143C7.54916 23.2143 2.72773 18.3929 2.72773 12.5C2.72773 6.60714 7.54916 1.78571 13.442 1.78571C19.3349 1.78571 24.1563 6.60714 24.1563 12.5C24.1563 18.3929 19.3349 23.2143 13.442 23.2143Z"
        fill="#AAAAAA"
      />
      <path
        d="M18.2636 18.75L13.4421 13.9286L8.62071 18.75L7.19214 17.3214L12.0136 12.5L7.19214 7.67857L8.62071 6.25L13.4421 11.0714L18.2636 6.25L19.6921 7.67857L14.8707 12.5L19.6921 17.3214L18.2636 18.75Z"
        fill="#AAAAAA"
      />
    </svg>
  );
}
export function ReviewApproveIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.31086 12.3369L4.392 11.3644L3.59771 10.7975C2.464 9.99184 1.71429 8.74043 1.71429 6.85703C1.71429 5.07078 2.38857 3.86279 3.40571 3.05938C4.472 2.21711 6.06286 1.71426 8 1.71426C9.93714 1.71426 11.528 2.21711 12.5943 3.05938C13.6114 3.86165 14.2857 5.07078 14.2857 6.85703C14.2857 8.64329 13.6114 9.85127 12.5943 10.6547C11.528 11.497 9.93714 11.9998 8 11.9998C7.91771 11.9998 7.83657 11.999 7.75657 11.9975L7.08229 11.9827L6.57943 12.4295L4.55657 14.2261C4.52167 14.2567 4.47839 14.2763 4.4323 14.2822C4.38621 14.2881 4.3394 14.2801 4.29788 14.2592C4.25636 14.2384 4.22204 14.2055 4.1993 14.165C4.17657 14.1245 4.16646 14.0781 4.17029 14.0318L4.31086 12.3369ZM7.71771 13.7106L5.696 15.5083C5.4051 15.7668 5.04343 15.9322 4.65763 15.9832C4.27183 16.0342 3.8796 15.9684 3.53153 15.7944C3.18346 15.6204 2.89551 15.3461 2.70482 15.0068C2.51414 14.6676 2.42946 14.279 2.46171 13.8912L2.60229 12.1952C1.00229 11.0558 0 9.27642 0 6.85703C0 2.28568 3.58171 0 8 0C12.4183 0 16 2.28568 16 6.85703C16 11.4284 12.4183 13.7141 8 13.7141C7.90552 13.7141 7.81143 13.7129 7.71771 13.7106ZM8.85714 4.57135C8.85714 4.34403 8.76684 4.12602 8.60609 3.96527C8.44535 3.80453 8.22733 3.71423 8 3.71423C7.77267 3.71423 7.55465 3.80453 7.39391 3.96527C7.23316 4.12602 7.14286 4.34403 7.14286 4.57135V5.9999H5.71429C5.48696 5.9999 5.26894 6.09021 5.10819 6.25095C4.94745 6.41169 4.85714 6.62971 4.85714 6.85703C4.85714 7.08436 4.94745 7.30237 5.10819 7.46311C5.26894 7.62386 5.48696 7.71416 5.71429 7.71416H7.14286V9.14271C7.14286 9.37003 7.23316 9.58805 7.39391 9.74879C7.55465 9.90953 7.77267 9.99984 8 9.99984C8.22733 9.99984 8.44535 9.90953 8.60609 9.74879C8.76684 9.58805 8.85714 9.37003 8.85714 9.14271V7.71416H10.2857C10.513 7.71416 10.7311 7.62386 10.8918 7.46311C11.0526 7.30237 11.1429 7.08436 11.1429 6.85703C11.1429 6.62971 11.0526 6.41169 10.8918 6.25095C10.7311 6.09021 10.513 5.9999 10.2857 5.9999H8.85714V4.57135Z"
        fill="#555555"
      />
    </svg>
  );
}

export function ArrowUpDesgined() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M71.1879 34.0419L37.9591 0.812154C37.7019 0.554689 37.3965 0.350439 37.0604 0.211083C36.7242 0.0717279 36.3639 0 36 0C35.6361 0 35.2758 0.0717279 34.9396 0.211083C34.6035 0.350439 34.2981 0.554689 34.0409 0.812154L0.812132 34.0419C0.424431 34.4292 0.160353 34.9228 0.0533274 35.4603C-0.053698 35.9977 0.00114222 36.5548 0.210906 37.0611C0.420669 37.5674 0.775923 38 1.23169 38.3042C1.68746 38.6085 2.22326 38.7707 2.77124 38.7702H16.6166V47.0777C16.6166 47.8121 16.9083 48.5164 17.4276 49.0358C17.9469 49.5551 18.6512 49.8468 19.3856 49.8468H52.6144C53.3488 49.8468 54.0531 49.5551 54.5724 49.0358C55.0917 48.5164 55.3834 47.8121 55.3834 47.0777V38.7702H69.2288C69.7767 38.7707 70.3125 38.6085 70.7683 38.3042C71.2241 38 71.5793 37.5674 71.7891 37.0611C71.9989 36.5548 72.0537 35.9977 71.9467 35.4603C71.8396 34.9228 71.5756 34.4292 71.1879 34.0419ZM52.6144 33.2319C51.88 33.2319 51.1757 33.5237 50.6564 34.043C50.1371 34.5623 49.8453 35.2667 49.8453 36.0011V44.3085H22.1547V36.0011C22.1547 35.2667 21.8629 34.5623 21.3436 34.043C20.8243 33.5237 20.12 33.2319 19.3856 33.2319H9.45507L36 6.68621L62.5449 33.2319H52.6144ZM55.3834 69.2309C55.3834 69.9653 55.0917 70.6696 54.5724 71.1889C54.0531 71.7083 53.3488 72 52.6144 72H19.3856C18.6512 72 17.9469 71.7083 17.4276 71.1889C16.9083 70.6696 16.6166 69.9653 16.6166 69.2309C16.6166 68.4964 16.9083 67.7921 17.4276 67.2728C17.9469 66.7535 18.6512 66.4617 19.3856 66.4617H52.6144C53.3488 66.4617 54.0531 66.7535 54.5724 67.2728C55.0917 67.7921 55.3834 68.4964 55.3834 69.2309ZM55.3834 58.1543C55.3834 58.8887 55.0917 59.593 54.5724 60.1124C54.0531 60.6317 53.3488 60.9234 52.6144 60.9234H19.3856C18.6512 60.9234 17.9469 60.6317 17.4276 60.1124C16.9083 59.593 16.6166 58.8887 16.6166 58.1543C16.6166 57.4198 16.9083 56.7155 17.4276 56.1962C17.9469 55.6769 18.6512 55.3851 19.3856 55.3851H52.6144C53.3488 55.3851 54.0531 55.6769 54.5724 56.1962C55.0917 56.7155 55.3834 57.4198 55.3834 58.1543Z"
        fill="currentColor"
      />
    </svg>
  );
}
